import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-431ba682"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cards-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "card-back bring-to-front"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isInsideShuttle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock($setup["MainCardShuttle"], {
            ref: "mainCardShuttle",
            key: $setup.updateKey,
            favoriteLine: $props.favoriteLine,
            onUpdateBusLocation: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('updateBusLocation'))),
            onOnClickLineInfo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClickLineInfo', $props.favoriteLine))),
            onOnClickScheduleBtn: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onClickScheduleBtn', $event))),
            onOnClickBusStopLocation: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onClickBusStopLocation', $event))),
            onOnClickBusImage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onClickBusImage')))
          }, null, 8 /* PROPS */, ["favoriteLine"]))
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($setup.shouldRenderCard(true))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["card-front", {
          'bring-to-front': $setup.shouldShowFront,
          'bring-to-back': !$setup.shouldShowFront,
          animate: $setup.startAnimation,
        }])
              }, [
                (_openBlock(), _createBlock($setup["MainCardFront"], {
                  ref: "mainCardFront",
                  key: $setup.updateKey,
                  favoriteLine: $props.favoriteLine,
                  cardIndex: $props.cardIndex,
                  currentCardIndex: $props.currentCardIndex,
                  onBoardLine: $props.onBoardLine,
                  isInsideShuttle: $setup.isInsideShuttle,
                  onOnClickLineInfo: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('onClickLineInfo', $props.favoriteLine))),
                  onOnClickBusStopLocation: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('onClickBusStopLocation', $event))),
                  onOnChangedCheck: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('onChangedCheck', $event))),
                  onOnClickReportBtn: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('onClickReportBtn')))
                }, null, 8 /* PROPS */, ["favoriteLine", "cardIndex", "currentCardIndex", "onBoardLine", "isInsideShuttle"]))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          ($setup.shouldRenderCard(false))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["card-back", {
          'bring-to-front': !$setup.shouldShowFront,
          'bring-to-back': $setup.shouldShowFront,
          animate: $setup.startAnimation,
        }])
              }, [
                (_openBlock(), _createBlock($setup["MainCardBack"], {
                  ref: "mainCardBack",
                  key: $setup.updateKey,
                  favoriteLine: $props.favoriteLine,
                  isInsideShuttle: $setup.isInsideShuttle,
                  onOnClickLineInfo: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('onClickLineInfo', $props.favoriteLine))),
                  onUpdateBusLocation: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('updateBusLocation'))),
                  onOnClickBusStopLocation: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('onClickBusStopLocation', $event))),
                  onOnClickBusImage: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('onClickBusImage')))
                }, null, 8 /* PROPS */, ["favoriteLine", "isInsideShuttle"]))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}